import { CSSProperties } from 'react';
import { FelaCSS, colors } from '@bridebook/ui';

interface IStyleProps {
  isMobile?: boolean;
  nameWidth?: number;
  fullBleed?: boolean;
}

interface IStyles {
  townName: FelaCSS;
  deleteWrap: FelaCSS;
  featuredMarkerWrap: FelaCSS;
  iconWrap: FelaCSS;
  imgContentWrap: FelaCSS;
  statsWrap: FelaCSS;
  contactedWrap: FelaCSS;
  location: FelaCSS;
  featured: FelaCSS;
  featuredTownName: FelaCSS;
  locationIcon: CSSProperties;
  saveToShort: FelaCSS;
}

const styles = ({ isMobile, fullBleed, nameWidth }: IStyleProps): IStyles => ({
  townName: {
    marginLeft: '4px',
  },

  featuredTownName: {
    paddingLeft: '4px',
    display: 'block',
    maxWidth: nameWidth || 220,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  deleteWrap: fullBleed
    ? {
        position: 'absolute',
        left: 0,
        top: 0,
        padding: 4,

        maxWidthTabletSm: {
          padding: 3,
        },
      }
    : {
        position: 'absolute',
        right: '3px',
        bottom: '-6px',
      },
  featuredMarkerWrap: {
    position: 'absolute',
    zIndex: 2,
    left: '0',
    bottom: isMobile ? '-1px' : '0',
    width: '100%',
  },

  iconWrap: {
    marginRight: '4px',
  },

  imgContentWrap: {
    flexDirection: 'row',
    position: 'absolute',
    zIndex: 3,
    paddingLeft: '10px',
    paddingRight: '10px',
    left: '0',
    top: '0',
    width: '100%',
  },

  contactedWrap: {
    marginRight: '7px',
  },

  statsWrap: {
    position: 'relative',
    flexGrow: 1,
    minWidth: '50%',
    color: colors.white,
    flexDirection: 'row',
    alignItems: 'center',
  },

  location: {
    flexDirection: 'row',
    alignItems: 'center',
    fontDefault: 10,
    lineHeight: '12px',
    marginTop: 4,
  },

  locationIcon: {
    fontSize: '11px',
  },

  featured: {
    backgroundColor: colors.blueCrush,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '2px',
    padding: '6px',
    fontDefault: 10,
    lineHeight: '12px',
    position: 'absolute',
    top: 0,
    left: '-10px',
    borderTopLeftRadius: '4px',
  },
  saveToShort: {
    position: 'absolute',
    top: 16,
    right: fullBleed ? 16 : 0,
    maxWidthTabletSm: {
      top: 12,
    },
  },
});

export default styles;
